import React from 'react';

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import { Spinner } from 'react-bootstrap';

import Chat from '../components/chat/Chat';

import QnA from '../components/qna/QnA';

import Polls from '../components/polls/Polls';

import Profile from '../components/profile/Profile';

import Login from '../components/login/Login';

import SelectOrganization from '../components/organization/SelectOrganization';

import Dashboard from '../components/dashboard/Dashboard';

import UserManagement from '../components/userManagement/UserManagement';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../platform/app-layout.css';
import '../platform/platform-module-shell.css';
import '../platform/platform-theme.css';
import '../platform/platform-content-list.css';
import '../platform/platform-content-list-premium.css';
import '../platform/platform-content-attachments.css';
import '../platform/platform-content-pdf-embed.css';
import '../platform/platform-content-detail.css';
import '../platform/platform-content-detail-premium.css';

import ChatRoom from '../components/chat/ChatRoom';

import ChatRoomManagement from '../components/chat/ChatRoomManagement';

import Notices from '../components/notices/Notices';

import Gallery from '../components/gallery/Gallery';

import Documents from '../components/documents/Documents';

import Sindikalist from '../components/sindikalist/Sindikalist';

import Article from '../components/articles/Article';

import Benefits from '../components/benefits/Benefits';

import Contact from '../components/contacts/Contact';

import { UserProvider, useUser } from '../context/UserContext';

import { LastReadProvider } from '../context/LastReadContext';
import { NotificationsProvider } from '../context/NotificationsContext';
import { ConfirmProvider } from '../platform/confirm/ConfirmProvider';
import { ToastProvider } from '../platform/toast/ToastProvider';

import { MembershipProvider } from '../context/MembershipContext';

import { TenantProvider, useTenant } from '../context/TenantContext';

import { TenantBrandingEffect } from '../platform/TenantBrandingEffect';

import { getDefaultModulePath } from '../platform/moduleNavigation';

import { ModuleRouteGuard } from '../platform/ModuleRouteGuard';

import { MODULE_IDS } from '../platform/constants';

import { TenantConfigReloader } from '../components/tenant/TenantConfigReloader';

import DeactivatedAccountGate from '../components/profile/DeactivatedAccountGate';

import { isAccountDeactivated } from '../platform/accountLifecycle';



function AppRoutes() {

  const {
    user,
    profileComplete,
    loading,
    blockingTenantLogin,
    setUser,
    setProfileComplete,
  } = useUser();

  const handleProfileComplete = (updatedProfile) => {
    setProfileComplete(true);
    if (updatedProfile) {
      setUser(updatedProfile);
    }
  };

  const { config, hasSelectedOrganization } = useTenant();

  const defaultModulePath = config ? getDefaultModulePath(config) : '/';

  const isAuthenticated = Boolean(user) && !blockingTenantLogin;



  if (loading || (isAuthenticated && !config)) {

    return (

      <div className="d-flex justify-content-center align-items-center vh-100">

        <Spinner animation="border" role="status">

          <span className="visually-hidden">Nalaganje...</span>

        </Spinner>

      </div>

    );

  }

  if (user && isAccountDeactivated(user)) {
    return <DeactivatedAccountGate />;
  }



  if (!isAuthenticated) {

    return (

      <Routes>

        <Route path="/select-organization" element={<SelectOrganization />} />

        <Route

          path="/login"

          element={hasSelectedOrganization ? <Login /> : <Navigate to="/select-organization" replace />}

        />

        <Route path="*" element={<Navigate to="/select-organization" replace />} />

      </Routes>

    );

  }



  return (

    <Routes>

      {profileComplete ? (

        <Route path="/" element={<Dashboard />}>

          <Route index element={<Navigate to={defaultModulePath} replace />} />

          <Route path="chat" element={<ModuleRouteGuard moduleId={MODULE_IDS.CHAT}><Chat /></ModuleRouteGuard>} />

          <Route path="chat/manage" element={<ModuleRouteGuard moduleId={MODULE_IDS.CHAT}><ChatRoomManagement /></ModuleRouteGuard>} />

          <Route path="chat/:unitId" element={<ModuleRouteGuard moduleId={MODULE_IDS.CHAT}><ChatRoom /></ModuleRouteGuard>} />

          <Route path="qna" element={<ModuleRouteGuard moduleId={MODULE_IDS.QNA}><QnA /></ModuleRouteGuard>} />

          <Route path="polls" element={<ModuleRouteGuard moduleId={MODULE_IDS.POLLS}><Polls /></ModuleRouteGuard>} />

          <Route path="notices" element={<ModuleRouteGuard moduleId={MODULE_IDS.NOTICES}><Notices /></ModuleRouteGuard>} />

          <Route path="gallery" element={<ModuleRouteGuard moduleId={MODULE_IDS.GALLERY}><Gallery /></ModuleRouteGuard>} />

          <Route path="documents" element={<ModuleRouteGuard moduleId={MODULE_IDS.DOCUMENTS}><Documents /></ModuleRouteGuard>} />

          <Route path="sindikalist" element={<ModuleRouteGuard moduleId={MODULE_IDS.SINDIKALIST}><Sindikalist /></ModuleRouteGuard>} />

          <Route path="article" element={<ModuleRouteGuard moduleId={MODULE_IDS.ARTICLES}><Article /></ModuleRouteGuard>} />

          <Route path="profile" element={<ModuleRouteGuard moduleId={MODULE_IDS.PROFILE}><Profile onProfileComplete={handleProfileComplete} /></ModuleRouteGuard>} />

          <Route path="benefits" element={<ModuleRouteGuard moduleId={MODULE_IDS.BENEFITS}><Benefits /></ModuleRouteGuard>} />

          <Route path="contact" element={<ModuleRouteGuard moduleId={MODULE_IDS.CONTACTS}><Contact /></ModuleRouteGuard>} />

          <Route path="user-management" element={<ModuleRouteGuard moduleId={MODULE_IDS.USER_MANAGEMENT}><UserManagement /></ModuleRouteGuard>} />

          <Route path="*" element={<Navigate to={defaultModulePath} replace />} />

        </Route>

      ) : (

        <Route path="/" element={<Dashboard />}>

          <Route path="profile" element={<Profile onProfileComplete={handleProfileComplete} />} />

          <Route path="*" element={<Navigate to="/profile" />} />

        </Route>

      )}

      <Route path="/select-organization" element={<Navigate to="/" replace />} />

      <Route path="/login" element={<Navigate to="/" replace />} />

      <Route path="*" element={<Navigate to={profileComplete ? defaultModulePath : '/profile'} replace />} />

    </Routes>

  );

}



function App() {

  return (

    <TenantProvider>

      <TenantBrandingEffect />

      <UserProvider>

        <LastReadProvider>

        <NotificationsProvider>

        <ConfirmProvider>

        <ToastProvider>

        <MembershipProvider>

          <TenantConfigReloader />

          <Router>

            <AppRoutes />

          </Router>

        </MembershipProvider>

        </ToastProvider>

        </ConfirmProvider>

        </NotificationsProvider>

        </LastReadProvider>

      </UserProvider>

    </TenantProvider>

  );

}



export default App;

